import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "External Component Box Types",
description: "API reference for the box types used to embed external (Svelte) components in Freon projections—simple additions, wrappers, and replacers—with syntax and wiring steps.",
tags: [ "external components", "box types", "wrappers", "replacers", "editor", "RenderComponent", "Svelte", "Freon"] ,
modifiedTime: "2025-11-07T18:18:47.845Z",
publishedTime: "2025-11-07T17:20:18.626Z"
    }
  };
};